import React from "react";
import { Box, Icon } from "@chakra-ui/react";
import { MotionG } from "ui/chakra-motion";
import { iconSize, pathDraw, type MediaProps } from "./shared";

export function CdpMedia({ isActive }: MediaProps) {
  return (
    <Icon fill="none" viewBox="0 0 75 75" boxSize={iconSize}>
      <Box as="g" fill="new.green.500">
        <Box
          as="path"
          fill-rule="evenodd"
          d="M40.625 9.375a3.125 3.125 0 1 1 0 6.25H18.75a3.125 3.125 0 0 0-3.125 3.125v37.5c0 1.726 1.4 3.125 3.125 3.125h3.436c1.448-7.132 7.755-12.5 15.314-12.5 7.56 0 13.866 5.368 15.314 12.5h3.436c1.726 0 3.125-1.4 3.125-3.125v-25a3.125 3.125 0 1 1 6.25 0v25a9.375 9.375 0 0 1-9.375 9.375h-37.5a9.375 9.375 0 0 1-9.375-9.375v-37.5a9.375 9.375 0 0 1 9.375-9.375h21.875ZM37.5 53.125a9.378 9.378 0 0 0-8.84 6.25h17.68a9.378 9.378 0 0 0-8.84-6.25Z"
          clip-rule="evenodd"
        />
        <Box
          as="path"
          fill-rule="evenodd"
          d="M37.5 21.875c6.04 0 10.938 4.897 10.938 10.938 0 6.04-4.898 10.937-10.938 10.937-6.04 0-10.937-4.897-10.938-10.938 0-6.04 4.897-10.937 10.938-10.937Zm0 6.25a4.688 4.688 0 1 0 0 9.375 4.688 4.688 0 0 0 0-9.375Z"
          clip-rule="evenodd"
        />
        <Box
          as="path"
          d="M57.285 4.81c.484-2.247 3.692-2.246 4.177 0l.238 1.1a5.554 5.554 0 0 0 4.26 4.264l1.102.234c2.25.484 2.25 3.695 0 4.178l-1.101.238a5.553 5.553 0 0 0-4.26 4.26l-.239 1.102c-.483 2.25-3.694 2.25-4.178 0l-.234-1.101a5.554 5.554 0 0 0-4.264-4.26l-1.101-.239c-2.246-.485-2.247-3.693 0-4.178l1.101-.234A5.555 5.555 0 0 0 57.05 5.91l.235-1.101Z"
        />
      </Box>
      <MotionG variants={pathDraw} initial="initial" animate={isActive ? "animate" : "initial"}>
        <Box
          as="path"
          fill-rule="evenodd"
          d="M40.625 9.375a3.125 3.125 0 1 1 0 6.25H18.75a3.125 3.125 0 0 0-3.125 3.125v37.5c0 1.726 1.4 3.125 3.125 3.125h3.436c1.448-7.132 7.755-12.5 15.314-12.5 7.56 0 13.866 5.368 15.314 12.5h3.436c1.726 0 3.125-1.4 3.125-3.125v-25a3.125 3.125 0 1 1 6.25 0v25a9.375 9.375 0 0 1-9.375 9.375h-37.5a9.375 9.375 0 0 1-9.375-9.375v-37.5a9.375 9.375 0 0 1 9.375-9.375h21.875ZM37.5 53.125a9.378 9.378 0 0 0-8.84 6.25h17.68a9.378 9.378 0 0 0-8.84-6.25Z"
          clip-rule="evenodd"
          fill="new.green.700"
          stroke="new.green.700"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Box
          as="path"
          fill-rule="evenodd"
          d="M37.5 21.875c6.04 0 10.938 4.897 10.938 10.938 0 6.04-4.898 10.937-10.938 10.937-6.04 0-10.937-4.897-10.938-10.938 0-6.04 4.897-10.937 10.938-10.937Zm0 6.25a4.688 4.688 0 1 0 0 9.375 4.688 4.688 0 0 0 0-9.375Z"
          clip-rule="evenodd"
          fill="new.green.700"
          stroke="new.green.700"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Box
          as="path"
          d="M57.285 4.81c.484-2.247 3.692-2.246 4.177 0l.238 1.1a5.554 5.554 0 0 0 4.26 4.264l1.102.234c2.25.484 2.25 3.695 0 4.178l-1.101.238a5.553 5.553 0 0 0-4.26 4.26l-.239 1.102c-.483 2.25-3.694 2.25-4.178 0l-.234-1.101a5.554 5.554 0 0 0-4.264-4.26l-1.101-.239c-2.246-.485-2.247-3.693 0-4.178l1.101-.234A5.555 5.555 0 0 0 57.05 5.91l.235-1.101Z"
          fill="new.green.700"
          stroke="new.green.700"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </MotionG>
    </Icon>
  );
}
